import { useEffect, useRef } from 'react';
import axios from '../axios/Axios';
import { useAuthentication } from '../context/AuthProvider';
import { useLocalStorage } from './useLocalStorage';

export const useAppConfig = (key) => {
    const { accessToken } = useAuthentication();

    const [config, setConfig] = useLocalStorage(key, null);

    const hasFetchedOnce = useRef(false); 

    useEffect(() => {
        if (accessToken && (!hasFetchedOnce.current || config === null)) {
            axios.get(`/configs/${key}`, { 
                headers: { 
                    Authorization: `Bearer ${accessToken}` 
                }
            })
            .then((res) => {
                const configValue = res.data.payload?.value
                if (!configValue) return;
                setConfig(configValue);
                hasFetchedOnce.current = true;
            });
        }
    }, [accessToken])

    return config;
}
